module.exports = __webpack_public_path__ + "static/xlm-e7e340039be3c4aa1cb29742fb1cd7a2.png";